import { NEXT_ROUTING_PATH_REGEXS, Env } from '@/constants/route/nextRoute';
import { env } from '@/utils/env';

const stage = (env('NEXT_PUBLIC_ENV') ?? Env.dev) as Env;

const NEXT_ROUTING_PATH = NEXT_ROUTING_PATH_REGEXS.get(stage) ?? [];

export const sanitizeURL = (
  route: string,
): {
  isNextRoute: boolean;
  url: string;
} => {
  // Handle special protocols like mailto:, tel:, etc.
  if (/^(mailto:|tel:|sms:|blob:|file:|data:|javascript:)/i.test(route)) {
    return {
      isNextRoute: false,
      url: route,
    };
  }

  if (/^(https?:\/\/|\/\/)/i.test(route)) {
    return {
      isNextRoute: false,
      url: route,
    };
  }

  if (route.startsWith('/')) {
    const isNextPath = NEXT_ROUTING_PATH.some((regex) => regex.test(route));

    if (isNextPath) {
      return {
        isNextRoute: true,
        url: route,
      };
    }

    return {
      isNextRoute: false,
      url: `${env('NEXT_PUBLIC_ENV_FRONTEND_ORIGIN')}${route}`,
    };
  }

  return {
    isNextRoute: false,
    url: route,
  };
};
